import { all, takeLatest, put } from 'redux-saga/effects';
import { GET_DATA_MANAGEMENT, UPDATE_DATA_MANAGEMENT } from './constants';
import {
    requestDataManagement,
    requestUpdateDataManagement
} from './api';
import {
    getDataManagementSuccess,
    updateDataManagementSuccess
} from './actions';

/**
 *
 * @returns {IterableIterator<PutEffect<{response: *, type: string}>>}
 */
function* getDataManagement() {
    const response = yield requestDataManagement();
    if (response) {
        yield put(getDataManagementSuccess(response));
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{response, type}>>}
 */
function* updateDataManagement(actionObj) {
    try {
        const response = yield requestUpdateDataManagement(actionObj.formData);
        yield put(updateDataManagementSuccess(response));
    } catch (error) {
        console.log("error " + error);
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchDataManagement() {
    yield takeLatest(GET_DATA_MANAGEMENT, getDataManagement);
    yield takeLatest(UPDATE_DATA_MANAGEMENT, updateDataManagement);
}

function* dataManagementSaga() {
    yield all([
        watchDataManagement()
    ]);
}

export default dataManagementSaga;